export default "__VITE_ASSET__ChPENTWQ__"